/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    changePassword: {
        innerText: "Changer de mot de passe"
    },
    changePasswordTitle: {
        title: "Modification du mot de passe"
    },
    confirmChange: {
        innerHTML: "Confirmer"
    },
    firstPassword: {
        label: "Mot de passe"
    },
    minLengthRequirement: {
        innerText: "Longueur minimale"
    },
    minLowercaseRequirement: {
        innerText: "Minuscules"
    },
    minNumberRequirement: {
        innerText: "Chiffres"
    },
    minSpecialRequirement: {
        innerText: "Caractères spéciaux"
    },
    minUppercaseRequirement: {
        innerText: "Majuscules"
    },
    passwordMatchRequirement: {
        innerText: "Correspondance des mots de passes"
    },
    secondPassword: {
        label: "Confimation mot de passe"
    },
    tmpPasswordLabel: {
        label: "Changer le mot de passe à la prochaine connexion"
    }
};